import { render, staticRenderFns } from "./valorizacaoStock.vue?vue&type=template&id=55d47326&scoped=true&"
import script from "./valorizacaoStock.vue?vue&type=script&lang=js&"
export * from "./valorizacaoStock.vue?vue&type=script&lang=js&"
import style0 from "./valorizacaoStock.vue?vue&type=style&index=0&id=55d47326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d47326",
  null
  
)

export default component.exports